module.exports = __webpack_public_path__ + "img/historial.4c764b19.svg";